/* Runspire: compra rapida no card. Bolinhas de cor embaixo da foto (tocar troca a foto). Desktop: faixa de modelo e tamanho ao passar o mouse, Comprar abre a sacola lateral. Celular: icone de sacola no card abre uma folha com o tamanho; ao adicionar, confirma por 3 segundos e fecha sozinha. */
(function () {
  if (window.__rsQuick) return;
  window.__rsQuick = true;
  var cache = {}, sheet = null, sheetBox = null, timer = null;
  var mq = window.matchMedia('(hover: none), (max-width: 749px)');
  var BAG = `<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M5 8h14l-1 12H6z'/><path d='M9 8V6a3 3 0 0 1 6 0v2'/></svg>`;
  var X = `<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M5 5l14 14M19 5L5 19'/></svg>`;
  var OK = `<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M5 12.5l4.5 4.5L19 7.5'/></svg>`;
  /* mesmas cores do seletor da pagina de produto (snippets/product-variant-options.liquid); ao criar cor nova, incluir nos dois. Nome fora daqui vira botao de texto */
  var SW = { 'branca': '#ffffff', 'branco': '#ffffff', 'off white': '#f1ede4', 'areia': '#d8c8a8', 'bege': '#c9b79c', 'preta': '#121212', 'preto': '#121212', 'marinho': '#1b2a4a', 'azul bebê': '#a9cbe8', 'azul bebe': '#a9cbe8', 'cinza': '#9ba1a8', 'chumbo': '#444343', 'verde': '#28382d', 'verde jade': '#2d6855', 'verde musgo': '#5a6b3a', 'verde oliva': '#6b6b3c', 'rosa': '#9b7a76', 'rosa bebê': '#f4cfd9', 'rosa bebe': '#f4cfd9', 'vermelho': '#c0392b', 'bordeaux': '#6d1f2c', 'bordô': '#6d1f2c', 'bordo': '#6d1f2c', 'marrom monte carlo': '#4f3528', 'amarelo': '#f0c23a' };
  /* ordem dos tamanhos: algumas poliamidas tem as variantes cadastradas fora de ordem */
  var SIZE_ORDER = ['PP', 'P', 'M', 'G', 'GG', 'EG', 'XG', 'GGG', '3G', 'G2', '4G', 'G3', 'G4'];

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function find(list, name) { var r = null; list.forEach(function (x) { if (x.name === name) r = x; }); return r; }
  /* nomes dos modelos como aparecem pro cliente */
  function styleLabel(n) { return /^masc/i.test(n) ? 'Masculino (unissex)' : /^fem/i.test(n) ? 'Feminino (baby look)' : n; }
  function sizeRank(n) { var i = SIZE_ORDER.indexOf(String(n).trim().toUpperCase()); return i < 0 ? 99 : i; }

  function product(handle) {
    if (!cache[handle]) cache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).catch(function () { delete cache[handle]; return null; });
    return cache[handle];
  }

  /* ---------- modelo de dados do produto ---------- */
  function model(p) {
    if (!p) return null;
    var avail = p.variants.filter(function (v) { return v.available; });
    if (!avail.length) return null;
    var si = -1, ci = -1, ti = -1;
    p.options.forEach(function (o, i) {
      if (/tamanho|size/i.test(o.name)) si = i; else if (/^cor|color/i.test(o.name)) ci = i; else if (/estilo|tipo|modelo/i.test(o.name)) ti = i;
    });
    if (si < 0) return p.variants.length === 1 ? { p: p, direct: p.variants[0].id } : null;
    var m = { p: p, si: si, ci: ci, ti: ti, base: avail[0].options };
    m.styles = stylesOf(m);
    return m;
  }
  function restOk(m, v) { return m.base.every(function (b, i) { return i === m.si || i === m.ci || i === m.ti || v.options[i] === b; }); }
  /* masculino sempre primeiro (e o que mais sai) */
  function stylesOf(m) {
    if (m.ti < 0) return [];
    var out = [];
    m.p.variants.forEach(function (v) {
      if (!restOk(m, v)) return;
      var s = v.options[m.ti], e = find(out, s);
      if (!e) { e = { name: s, ok: false }; out.push(e); }
      if (v.available) e.ok = true;
    });
    out.sort(function (a, b) { return (/^fem/i.test(a.name) ? 1 : 0) - (/^fem/i.test(b.name) ? 1 : 0); });
    return out;
  }
  function pool(m, st) { return m.p.variants.filter(function (v) { return restOk(m, v) && (m.ti < 0 || !st || !st.style || v.options[m.ti] === st.style); }); }
  function colorsFrom(m, list) {
    var out = [];
    if (m.ci < 0) return out;
    list.forEach(function (v) {
      var c = v.options[m.ci], e = find(out, c);
      if (!e) { e = { name: c, ok: false }; out.push(e); }
      if (v.available) e.ok = true;
    });
    return out;
  }
  function colorsOf(m, st) { return colorsFrom(m, pool(m, st)); }
  function allColors(m) { return colorsFrom(m, m.p.variants.filter(function (v) { return restOk(m, v); })); }
  function sizesFor(m, st) {
    var list = pool(m, st).filter(function (v) { return m.ci < 0 || v.options[m.ci] === st.color; })
      .map(function (v) { return { id: v.id, name: v.options[m.si], ok: v.available }; });
    list.sort(function (a, b) { return sizeRank(a.name) - sizeRank(b.name); });
    return list;
  }
  /* foto da cor: do modelo escolhido; sem modelo escolhido, a do masculino (o que mais sai) */
  function imgFor(m, color, style) {
    var best = '', any = '';
    m.p.variants.forEach(function (v) {
      if (!restOk(m, v) || !v.featured_image || (m.ci > -1 && v.options[m.ci] !== color)) return;
      var s = m.ti > -1 ? v.options[m.ti] : '';
      if (!any) any = v.featured_image.src;
      if (!best && (style ? s === style : !/^fem/i.test(s))) best = v.featured_image.src;
    });
    return best || any;
  }

  /* ---------- estado: modelo, cor e tamanho escolhidos ---------- */
  function styleKnown(st) { return st.m.ti < 0 || !!st.style; }
  /* acerta a cor conforme o modelo: usa a cor tocada no card se existir, senao a primeira com estoque */
  function settle(st) {
    if (!styleKnown(st)) { st.color = ''; return; }
    var pick = null, first = null;
    colorsOf(st.m, st).forEach(function (c) {
      if (!c.ok) return;
      if (!first) first = c;
      if (c.name === st.pref) pick = c;
    });
    pick = pick || first;
    st.color = pick ? pick.name : '';
    if (!pick || pick.name !== st.pref) st.pref = '';
  }
  function newState(m) {
    var st = { m: m, style: '', color: '', pref: '', sel: null };
    if (m.ti > -1 && m.styles.length < 2) st.style = m.base[m.ti];
    settle(st);
    return st;
  }

  function dot(c, cur) {
    var hex = SW[c.name.toLowerCase()], on = c.name === cur ? ' is-on' : '', dis = c.ok ? '' : ' disabled';
    if (hex) return `<button type='button' class='rs-chip rs-dot${on}' style='background:${hex}' title='${esc(c.name)}' aria-label='${esc(c.name)}' data-color='${esc(c.name)}'${dis}></button>`;
    return `<button type='button' class='rs-chip rs-chip--c${on}' data-color='${esc(c.name)}'${dis}>${esc(c.name)}</button>`;
  }
  /* modelo (se houver mais de um), cor (so se nao foi tocada no card) e tamanho */
  function pickHTML(st, named) {
    var m = st.m, h = '';
    if (m.styles.length > 1) {
      h += `<div class='rs-styles'>` + m.styles.map(function (s) {
        return `<button type='button' class='rs-chip rs-chip--s${s.name === st.style ? ' is-on' : ''}' data-style='${esc(s.name)}'${s.ok ? '' : ' disabled'}>${esc(styleLabel(s.name))}</button>`;
      }).join('') + `</div>`;
      if (!styleKnown(st)) return h + `<p class='rs-hint'>Escolha o modelo</p>`;
    }
    var cs = colorsOf(m, st);
    if (cs.length > 1 && !st.pref) h += `<div class='rs-colors'>` + cs.map(function (c) { return dot(c, st.color); }).join('') + `</div>`;
    if (cs.length > 0 && named) h += `<p class='rs-colorname'>Cor: <b>${esc(st.color)}</b></p>`;
    return h + `<div class='rs-qa__sizes'>` + sizesFor(m, st).map(function (s) {
      return `<button type='button' class='rs-chip' data-id='${s.id}'${s.ok ? '' : ' disabled'}>${esc(s.name)}</button>`;
    }).join('') + `</div>`;
  }
  /* clique numa bolinha de cor, de modelo ou de tamanho */
  function pickChip(root, st, chip, named, box, done) {
    if (chip.dataset.style || chip.dataset.color) {
      if (chip.dataset.style) st.style = chip.dataset.style; else st.pref = chip.dataset.color;
      st.sel = null;
      if (chip.dataset.color) st.color = chip.dataset.color;
      settle(st);
      root.innerHTML = pickHTML(st, named);
      sync(box);
      done(null);
      return;
    }
    st.sel = chip.dataset.id;
    root.querySelectorAll('.rs-chip[data-id]').forEach(function (x) { x.classList.toggle('is-on', x === chip); });
    done(st.sel);
  }

  /* ---------- bolinhas de cor embaixo da foto ---------- */
  /* a segunda foto do card (aparece no hover) sai: com ela, o tema deixava a foto trocada transparente ao passar o mouse */
  function setImage(card, url) {
    var imgs = card.querySelectorAll('.card__media img');
    if (!imgs.length || !url) return;
    imgs[0].removeAttribute('srcset');
    imgs[0].src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=720';
    for (var i = 1; i < imgs.length; i++) imgs[i].remove();
  }
  function sync(box) {
    var st = box.__st, card = box.closest('.card-wrapper');
    if (!st || !card) return;
    card.querySelectorAll('.rs-sw .rs-dot').forEach(function (d) { d.classList.toggle('is-on', d.dataset.color === st.pref); });
    if (st.pref) setImage(card, imgFor(st.m, st.pref, st.style));
  }
  /* uma cor so: a bolinha aparece mesmo assim, ja marcada, pra nao parecer que faltou */
  function renderSw(box) {
    var st = box.__st, card = box.closest('.card-wrapper');
    if (!st || st.m.direct || st.m.ci < 0 || card.querySelector('.rs-sw')) return;
    var cs = allColors(st.m).filter(function (c) { return c.ok; });
    if (cs.length < 1) return;
    var infos = card.querySelectorAll('.card__information'), info = infos[infos.length - 1];
    if (!info) return;
    var w = document.createElement('div');
    w.className = 'rs-sw';
    w.innerHTML = cs.map(function (c) { return dot(c, cs.length === 1 ? c.name : ''); }).join('');
    info.appendChild(w);
    w.addEventListener('click', function (e) {
      var c = e.target.closest('.rs-chip');
      if (!c || c.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      st.pref = c.dataset.color;
      st.sel = null;
      settle(st);
      st.pref = st.pref || c.dataset.color;
      box.querySelector('.rs-pick').innerHTML = pickHTML(st, false);
      box.querySelector('.rs-qa__buy').disabled = true;
      sync(box);
    });
  }

  /* ---------- carrinho ---------- */
  function add(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'erro'); return j; }); });
  }
  /* atualiza gaveta e contador sem abrir a gaveta (e tira a marca de gaveta vazia) */
  function paint(res) {
    var s = res.sections || {};
    function part(html, sel) { var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return el ? el.innerHTML : null; }
    var cur = document.querySelector('#CartDrawer'), h = s['cart-drawer'] && part(s['cart-drawer'], '#CartDrawer');
    if (cur && h) {
      cur.innerHTML = h;
      if (drawer()) drawer().classList.remove('is-empty');
      var ov = document.getElementById('CartDrawer-Overlay');
      if (ov) ov.addEventListener('click', function () { if (drawer()) drawer().close(); });
    }
    var b = document.getElementById('cart-icon-bubble'), h2 = s['cart-icon-bubble'] && part(s['cart-icon-bubble'], '.shopify-section');
    if (b && h2) b.innerHTML = h2;
  }
  function ladderMsg(res) {
    var h = res.sections && res.sections['cart-drawer'];
    if (!h) return '';
    var m = new DOMParser().parseFromString(h, 'text/html').querySelector('.rs-ladder__msg');
    return m ? m.innerHTML : '';
  }

  /* ---------- desktop: faixa no card ---------- */
  function buyDesktop(box, btn) {
    var st = box.__st;
    if (!st || !st.sel) return;
    btn.disabled = true;
    btn.textContent = 'Adicionando...';
    add(st.sel).then(function (res) {
      var d = drawer();
      /* sem isso, a pagina que carregou com a sacola vazia continuava marcada como vazia: sumia o titulo/fechar e dava erro de foco */
      if (d) d.classList.remove('is-empty');
      if (d && d.renderContents) d.renderContents(res); else { paint(res); if (d) d.open(); }
      st.sel = null;
      box.querySelector('.rs-pick').innerHTML = pickHTML(st, false);
      btn.textContent = 'Comprar';
    }).catch(function () { btn.textContent = 'Tentar de novo'; btn.disabled = false; });
  }
  function fill(box) {
    if (box.__fill) return box.__fill;
    box.__fill = product(box.dataset.handle).then(function (p) {
      var m = model(p);
      if (!m) { box.classList.add('rs-qa--off'); return; }
      var st = box.__st = newState(m);
      if (m.direct) { st.sel = m.direct; box.querySelector('.rs-qa__buy').disabled = false; return; }
      box.querySelector('.rs-pick').innerHTML = pickHTML(st, false);
      renderSw(box);
    });
    return box.__fill;
  }

  /* ---------- celular: folha ---------- */
  function show(s) { s.hidden = false; void s.offsetWidth; s.classList.add('is-open'); document.documentElement.classList.add('rs-sheet-lock'); }
  function close() {
    if (!sheet || sheet.hidden) return;
    clearTimeout(timer);
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('rs-sheet-lock');
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 300);
  }
  function ensureSheet() {
    if (sheet) return sheet;
    var s = sheet = document.createElement('div');
    s.className = 'rs-sheet';
    s.hidden = true;
    s.innerHTML = `<div class='rs-sheet__scrim'></div><div class='rs-sheet__panel' role='dialog' aria-modal='true' aria-labelledby='rs-sheet-title'><button type='button' class='rs-sheet__x' aria-label='Fechar'>${X}</button><div class='rs-sheet__body'></div></div>`;
    document.body.appendChild(s);
    s.addEventListener('click', function (e) {
      var t = e.target, st = sheetBox && sheetBox.__st;
      if (t.closest('.rs-sheet__x') || t.classList.contains('rs-sheet__scrim')) return close();
      var c = t.closest('.rs-chip');
      if (c && !c.disabled && st) {
        pickChip(s.querySelector('.rs-pick'), st, c, true, sheetBox, function (sel) {
          var a = s.querySelector('.rs-sheet__add');
          a.disabled = !sel;
          a.textContent = sel ? 'Adicionar à sacola' : 'Escolha o tamanho';
        });
        return;
      }
      if (t.closest('.rs-sheet__add') && st && st.sel) return sheetAdd(st.sel);
      if (t.closest('.rs-sheet__bag')) { var d = drawer(); close(); if (d) setTimeout(function () { d.open(); }, 200); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return s;
  }
  function sheetAdd(id) {
    var body = sheet.querySelector('.rs-sheet__body'), b = body.querySelector('.rs-sheet__add');
    if (b) { b.disabled = true; b.textContent = 'Adicionando...'; }
    add(id).then(function (res) {
      paint(res);
      var msg = ladderMsg(res);
      body.innerHTML = `<p class='rs-sheet__title rs-sheet__title--ok' id='rs-sheet-title'><i>${OK}</i>Adicionado à sacola</p>${msg ? `<p class='rs-sheet__msg'>${msg}</p>` : ''}<button type='button' class='rs-sheet__bag'>Ver sacola</button><span class='rs-sheet__bar'></span>`;
      clearTimeout(timer);
      timer = setTimeout(close, 3200);
    }).catch(function () {
      body.insertAdjacentHTML('beforeend', `<p class='rs-sheet__err'>Não foi possível adicionar agora. Tente de novo.</p>`);
      if (b) { b.disabled = false; b.textContent = 'Adicionar à sacola'; }
    });
  }
  function openSheet(box) {
    var s = ensureSheet(), body = s.querySelector('.rs-sheet__body');
    clearTimeout(timer);
    fill(box).then(function () {
      var st = box.__st;
      if (!st) { window.location.href = box.dataset.url; return; }
      sheetBox = box;
      st.sel = null;
      if (st.m.direct) { body.innerHTML = ''; show(s); st.sel = st.m.direct; sheetAdd(st.m.direct); return; }
      var title = st.m.styles.length > 1 ? 'Modelo e tamanho' : 'Selecione o tamanho';
      body.innerHTML = `<p class='rs-sheet__title' id='rs-sheet-title'>${title}</p><p class='rs-sheet__name'>${esc(st.m.p.title)}</p><div class='rs-sheet__sizes'><div class='rs-pick'>${pickHTML(st, true)}</div></div><button type='button' class='rs-sheet__add' disabled>Escolha o tamanho</button>`;
      show(s);
    });
  }

  /* ---------- liga os cards ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting) return; io.unobserve(e.target); fill(e.target); });
  }, { rootMargin: '300px' }) : null;

  function attach(card) {
    if (card.dataset.rsQa) return;
    card.dataset.rsQa = '1';
    var link = null;
    Array.prototype.some.call(card.getElementsByTagName('a'), function (x) {
      if ((x.getAttribute('href') || '').indexOf('/products/') > -1) { link = x; return true; }
    });
    var inner = card.querySelector('.card__inner');
    if (!link || !inner) return;
    var box = document.createElement('div');
    box.className = 'rs-qa';
    box.dataset.handle = link.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
    box.dataset.url = link.href;
    box.innerHTML = `<button type='button' class='rs-qa__bag' aria-label='Adicionar à sacola'>${BAG}</button><div class='rs-qa__strip'><div class='rs-pick'></div><button type='button' class='rs-qa__buy' disabled>Comprar</button></div>`;
    inner.appendChild(box);
    box.querySelector('.rs-qa__bag').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openSheet(box); });
    box.addEventListener('click', function (e) {
      var chip = e.target.closest('.rs-chip'), buy = e.target.closest('.rs-qa__buy');
      if (chip && !chip.disabled && box.__st) pickChip(box.querySelector('.rs-pick'), box.__st, chip, false, box, function (sel) { box.querySelector('.rs-qa__buy').disabled = !sel; });
      if (buy && !buy.disabled) buyDesktop(box, buy);
      if (chip || buy) { e.preventDefault(); e.stopPropagation(); }
    });
    card.addEventListener('pointerenter', function () { fill(box); });
    card.addEventListener('focusin', function () { fill(box); });
    if (io) io.observe(box);
  }

  var queued = false;
  function scan() { queued = false; document.querySelectorAll('.card-wrapper').forEach(attach); }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(scan); } }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
